import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import _ from 'lodash';

import classnames from 'classnames';
import connectToStores from "../../helpers/connectToStores";
import onClickOutside from "react-onclickoutside";
import DimensionsStore from '../../stores/DimensionsStore';
import BannerStore from '../../stores/BannerStore';

const getStateFromStores = () => ({
    viewportHeight: DimensionsStore.get('height'),
    hasBanner: Boolean(BannerStore.getActive())
});

function DropDown ({ children, show, onClose, viewportHeight, hasBanner }) {
    const [maxHeight, setMaxHeight] = React.useState('initial');
    const menuRef = React.useRef();

    useEffect(() => {
        if (show) {
            const boundingClientRect = menuRef.current.getBoundingClientRect();
            const distanceFromTop = boundingClientRect.y;
            const footerHeight = 40;
            setMaxHeight(viewportHeight - distanceFromTop - footerHeight);
        }
    }, [viewportHeight, hasBanner, show]);

    DropDown.handleClickOutside = () => onClose();

    const dropdownClasses = classnames('nav-list__dropdown', 'list-unstyled', 'no-margin', 'clearfix', {
        hidden: !show
    });

    return (
        <ul ref={menuRef} className={ dropdownClasses } role="menu" style={{ maxHeight }} aria-hidden={!show}>
            { children }
        </ul>
    );
}

const clickOutsideConfig = {
    handleClickOutside: () => DropDown.handleClickOutside
};

DropDown.propTypes = {
    children: PropTypes.node.isRequired,
    show: PropTypes.bool,
    onClose: PropTypes.func,
    viewportHeight: PropTypes.number,
    hasBanner: PropTypes.bool
};

DropDown.defaultProps = {
    show: false,
    onClose: _.noop
};

export default connectToStores([DimensionsStore, BannerStore], getStateFromStores)(onClickOutside(DropDown, clickOutsideConfig));




// WEBPACK FOOTER //
// ./src/components/nav/DropDown.js